// Teonox.ai data-testid registry. Keep kebab-case strings used across the app.
export const NAV = {
    headerLogo: 'site-header-logo',
    headerNav: 'site-header-nav',
    headerCta: 'site-header-primary-cta',
    mobileToggle: 'site-header-mobile-toggle',
    mobileNav: 'site-header-mobile-nav',
    stickyCta: 'sticky-mobile-cta',
    footer: 'site-footer',
};

export const HOME = {
    hero: 'home-hero',
    heroPrimaryCta: 'home-hero-primary-cta',
    heroSecondaryCta: 'home-hero-secondary-cta',
    scrollStory: 'home-scroll-story',
    masterclassSection: 'home-masterclass-section',
};

export const MASTERCLASS = {
    openButton: 'masterclass-open-button',
    drawer: 'masterclass-drawer',
    nameInput: 'masterclass-form-name-input',
    emailInput: 'masterclass-form-email-input',
    phoneInput: 'masterclass-form-phone-input',
    audienceSelect: 'masterclass-form-audience-select',
    interestInput: 'masterclass-form-interest-input',
    submitButton: 'masterclass-form-submit-button',
    successState: 'masterclass-form-success',
};

export const GAP = {
    page: 'gap-page',
    audienceCards: 'gap-audience-cards',
};

export const COURSES = {
    page: 'courses-page',
    viewToggle: 'courses-view-toggle',
    audienceSelector: 'audience-selector',
    audienceContinue: 'audience-continue-button',
    chatThread: 'consultant-chat-thread',
    chatInput: 'consultant-chat-input',
    chatSend: 'consultant-chat-send-button',
    shelf: 'course-shelf',
    matchBadge: 'course-match-badge',
    libraryGrid: 'courses-library-grid',
    libraryCard: 'courses-library-card',
};

export const RESULTS = {
    page: 'results-page',
    storyCard: 'results-story-card',
};

export const JOBRISK = {
    page: 'jobrisk-page',
    chatThread: 'jobrisk-chat-thread',
    chatInput: 'jobrisk-chat-input',
    chatSend: 'jobrisk-chat-send-button',
    dial: 'job-risk-probability-dial',
    severity: 'job-risk-severity',
    reasons: 'job-risk-reasons',
    recommendations: 'job-risk-course-recommendations',
    safeZones: 'job-risk-safe-zones',
    confidence: 'job-risk-confidence',
    resetButton: 'jobrisk-reset-button',
};
